export default {"src":"/_next/static/media/handcuffs_40.d5b46e58.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};